'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ColumnHeaderDirective=function(_BaseControllerBacked){_inherits(ColumnHeaderDirective,_BaseControllerBacked);function ColumnHeaderDirective(){_classCallCheck(this,ColumnHeaderDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}ColumnHeaderDirective.prototype.
















factory=function factory(){
let directive=_BaseControllerBacked.prototype.factory.call(this);
directive.replace=!0;
return directive;
};_createClass(ColumnHeaderDirective,[{key:'restrict',get:function(){return'A'}},{key:'objectBindings',get:function(){return['tableColumn','sortableTableController']}},{key:'templateUrl',get:function(){return'/templates/directives/columnHeaderDirective/columnHeaderTemplate'}},{key:'controller',get:function(){return ColumnHeaderDirectiveController}}]);return ColumnHeaderDirective}(BaseControllerBackedDirective);let


ColumnHeaderDirectiveController=function(){function ColumnHeaderDirectiveController(){_classCallCheck(this,ColumnHeaderDirectiveController)}_createClass(ColumnHeaderDirectiveController,[{key:'ascending',get:function()
{
return this.tableColumn.ascending;
}},{key:'isActive',get:function()

{
return this.tableColumn.isActive;
}},{key:'label',get:function()

{
return this.tableColumn.label;
}},{key:'orderBy',get:function()

{
return this.tableColumn.orderBy;
}},{key:'sortDisabled',get:function()

{
return this.tableColumn.sortDisabled;
}}]);return ColumnHeaderDirectiveController}();



module.exports=ColumnHeaderDirective;
//# sourceMappingURL=columnHeaderDirective.js.map
